import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesComponent } from './component/services.component';
import { SectionServicesModule } from '../section-services/section-services.module';
import { SectionTechnologiesModule } from '../section-technologies/section-technologies.module';
import { ServicesRoutingModule } from './services-routing.module';
import { PageHeaderModule } from '../page-header/page-header.module';



@NgModule({
  declarations: [
    ServicesComponent
  ],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    SectionServicesModule,
    SectionTechnologiesModule,
    PageHeaderModule
  ]
})
export class ServicesModule { }
